import { BaseItem, TableProps } from '@lib/components/Table/types';

export const checkHasActionsMenuColumn = <T extends BaseItem>({
  actionsMenu,
}: TableProps<T>): boolean => !!actionsMenu?.length;
